import { Routes } from '@angular/router';

import { HomeComponent } from 'app/home/home.component';
import { ContentComponent } from 'app/content/content.component';
import { TosComponent } from './tos/tos.component';
import { PrivacyComponent } from './privacy/privacy.component';

export const routes: Routes = [
    {
        path: '',
        title: "Kizano's FinTech",
        component: HomeComponent,
    },
    {
        path: 'content',
        children: [
            {
                path: '',
                component: HomeComponent,
                title: "Kizano's FinTech Content"
            },
            {
                path: ':category',
                component: ContentComponent,
                title: "Kizano's FinTech Content"
            }
        ]
    },
    {
        path: 'tos',
        title: "Kizano's FinTech Terms of Service",
        component: TosComponent,
    },
    {
        path: 'privacy',
        title: "Kizano's FinTech Privacy Policy",
        component: PrivacyComponent,
    }
];
